import React from 'react';
import {StyleSheet} from 'react-native';
import {Box} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import Markdown from 'react-native-markdown-display';
import InternalTemplate from '../../../../components/templates/internal';
import {StackParamList} from '../../../../navigators';
import {useContextState} from '../../../../context/user';

type ScreenProps = NativeStackScreenProps<StackParamList, 'Faq'>;

const FaqScreen = ({navigation}: ScreenProps) => {
  const handleGoBack = () => {
    navigation.navigate('Dashboard');
  };
  const {faq} = useContextState();

  return (
    <InternalTemplate
      title={'screen-faq-title'}
      backButton={{
        onPress: () => handleGoBack(),
        label: 'back-dashboard',
        usage: 'external',
      }}>
      <Box marginBottom="50%" paddingTop={5}>
        <Markdown style={styles} mergeStyle={true}>
          {faq ?? ''}
        </Markdown>
      </Box>
    </InternalTemplate>
  );
};

const styles = StyleSheet.create({
  body: {
    color: 'black',
  },
});

export default FaqScreen;
